<template>
  <template v-if="isSceneElementNode(sceneNode)">
    <target-menu
      v-if="isUidOfType(sceneNode.data.elementUid, 'target')"
      :key="`target-menu-${sceneNode.data.elementUid}`"
      :uid="(sceneNode.data.elementUid as Uid<'target'>)"
      :node-uid="sceneNode.uid"
      @select="selectSub"
      @deselect="deselectSub"
    />

    <resource-menu
      v-if=" isUidOfType(sceneNode.data.elementUid, 'resource')"
      :key="`resource-menu-${sceneNode.data.elementUid}`"
      :uid="(sceneNode.data.elementUid as Uid<'resource'>)"
      :node-uid="sceneNode.uid"
      :sub-selection="subSelection"
      @select="selectSub"
      @deselect="deselectSub"
      @delete="closeMenu()"
      @close="closeMenu()"
    />

    <index-menu
      v-if="features.index && isUidOfType(sceneNode.data.elementUid, 'index')"
      :key="`index-menu-${sceneNode.data.elementUid}`"
      :uid="(sceneNode.data.elementUid as Uid<'index'>)"
      :node-uid="sceneNode.uid"
      :sub-selection="subSelection"
      @select="selectSub"
      @deselect="deselectSub"
      @delete="closeMenu()"
      @close="closeMenu()"
    />
  </template>

  <scene-text-menu
    v-if="isSceneTextNode(sceneNode)"
    :key="`scene-text-menu-${sceneNode.id}`"
    :node-uid="sceneNode.uid"
    @close="closeMenu()"
  />

  <scene-shape-menu
    v-if="isSceneShapeNode(sceneNode)"
    :key="`scene-shape-menu-${sceneNode.id}`"
    :node-uid="sceneNode.uid"
    @close="closeMenu()"
  />

  <scene-medium-menu
    v-if="isSceneMediumNode(sceneNode)"
    :key="`scene-medium-menu-${sceneNode.id}`"
    :node-uid="sceneNode.uid"
    @close="closeMenu()"
  />
  
  <scene-chart-menu
    v-if="isSceneChartNode(sceneNode)"
    :key="`scene-chart-menu-${sceneNode.id}`"
    :node-uid="sceneNode.uid"
    @close="closeMenu()"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { isSceneElementNode } from '../sceneElement/sceneElementFunctions';
import { useSelectionStore } from '@editor/store/editor/selection.store';
import { useSceneNodesStore } from './sceneNodes.store';
import { useFeatureStore } from '@editor/store/features.store';

import TargetMenu from '../target/TargetMenu.vue';
import ResourceMenu from '../resource/ResourceMenu.vue';
import IndexMenu from '../index/IndexMenu.vue';
import SceneShapeMenu from '../sceneShape/SceneShapeMenu.vue';
import SceneTextMenu from '../sceneText/SceneTextMenu.vue';
import SceneChartMenu from '../sceneChart/SceneChartMenu.vue';
import SceneMediumMenu from '../sceneMedium/SceneMediumMenu.vue';

import { isUidOfType, type Uid } from '@/helpers/utility/Id';
import { isSceneShapeNode } from '../sceneShape/sceneShapeFunctions';
import { isSceneTextNode } from '../sceneText/sceneTextFunctions';
import { isSceneChartNode } from '../sceneChart/sceneChartFunctions';
import { isSceneMediumNode } from '../sceneMedium/sceneMediumFunctions';

const props = defineProps<{
  sceneNodeId: number;
}>();

const sceneNodeStore = useSceneNodesStore();
const features = useFeatureStore();
const selectionStore = useSelectionStore();

const sceneNode = computed(() => sceneNodeStore.items[props.sceneNodeId]);

const subSelection = computed(() => selectionStore.subSelection);

function closeMenu() {
  selectionStore.clearAll();
}

const selectSub = selectionStore.selectSub;
function deselectSub() {
  selectionStore.selectSub(null);
}
</script>

<style lang="scss">

</style>